import { Outlet, createRootRoute } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { isDev } from "@/env";

if (isDev) {
  console.debug("Running in development mode");
} else {
  console.debug("Running in production mode");
}

export const Route = createRootRoute({
  component: Outlet,
  notFoundComponent: () => <div>404 - Not Found</div>,
});
